<template>
  <div id="VideoDemo">
    <videoPlayer
      @titleClick="titleClick"
      :title="title"
      :options="options"
      @ready="ready"
      ref="videoPlayer"
    ></videoPlayer>
  </div>
</template>
<script>
import videoPlayer from "./index";

export default {
  name: "demo",
  components: {
    videoPlayer,
  },
  data() {
    return {
      title: "标题1",
      options: {
        sources: [
          {
            type: "video/mp4",
            src: require("../../assets/audio/video.mp4"),
          },
        ],
        // poster: "https://avatars.githubusercontent.com/u/499550?v=4",
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.title = "标题2";
    }, 5000);
  },
  methods: {
    titleClick(e, player) {
      //退出全屏
      this.$refs.videoPlayer.setFullScreen(false);
    },
    ready(player, vm) {
      player.on("pause", () => {
      });
    },
  },
};
</script>
